<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue" style="padding-left:50px;"><div class="section level2" id="prologue-1">
<div>
<p style="width:550px; padding-top:20px; padding-top:20px;  font-size:10pt;font-family:calibri;">were demolished by the waves. The deluge shocked the people into action. Thomas van Seeratt was vindicated and from that time onward dikes were built and maintained as a common enterprise.</p>
<p style="width:550px;  font-size:10pt;font-family:calibri;">Near Ten Boer, the low-lying countryside had been devastated. The farm of the young Harman was ravaged by the force of the flood. The house that he was extending in the hope of attracting a suitable bride was ruined – he had to start again. He had to work until he was well into his thirties before he could invite a bride to enter his rebuilt home. Over the years, their marriage was blessed with children, and Harman’s council was respected.</p>
<p style="width:550px;  font-size:10pt;font-family:calibri;">He became an elder of the church in Ten Boer, on Sundays he sat in the dark oak canopied pew reserved for notables and members of the consistory. Only sometimes during the long sermons would his thoughts drift out of the medieval brick church, through its heavy oak doors, and back through time to that night of the flood when he was sitting on a beam of a barn that was collapsing around him, with his cattle drowning in the swirling waters below his feet. It was then that he saw, in the fading light of the day, the box that Jan had made being carried away in the direction of the Wadden Sea, and into the dark of the night.</p>
<br/>
<p style="text-align: center; width:550px;"><img alt="" src="media/end.PNG" style="width:32px; height:30px;"/></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0013.vue?199ac8e4